import { AfterViewChecked, Component, OnInit } from '@angular/core';
import { CommonDataService } from '../../common/services/common-data.service';
import { LoginService } from '../../common/services/Login.service';
import { GraphqlService } from '../../common/services/graphql.service';
import { DomSanitizer } from '@angular/platform-browser';
import { OpenLinkById } from '../../common/services/openlinkbyid';


@Component({
  selector: 'app-concepts-statements',
  templateUrl: './concepts-statements.component.html',
  styleUrls: ['./concepts-statements.component.css']
})
export class ConceptsStatementsComponent implements OnInit, AfterViewChecked {

  constructor(
    public commonDataService: CommonDataService,
    public loginService: LoginService,
    private graphQlService: GraphqlService,
    private sanitizer: DomSanitizer,
    private openlink: OpenLinkById) { }
  cs_header;
  cs_description;
  cs_notesAboutUsingHeader;
  cs_notesAboutUsingBody;
  cs_notesAboutUsingLink;
  cs_copyrightNoticeHeader;
  cs_copyrightNoticeBody;
  cs_copyrightNoticeLink;
  cs_archiveLibraryDescription;
  cs_downloadLink;
  cs_content;
  cs_content_arr = [];
  cs_supersededcontent;
  cs_supersededrequestheader;
  cs_superseded_arr = [];
  s3baseurl: string;
  ngOnInit(): void {
    
    this.commonDataService.showLoader.next(true);
    this.firstTimeFlag = true;
    this.getconceptsstatementslabels();
    this.graphQlService.getS3BucketPath().subscribe(data => {
      this.s3baseurl = data;
    });
  }

  firstTimeFlag: boolean = true;
  ngAfterViewChecked() {
    if (this.firstTimeFlag) {
      this.anchorColorChange();
      this.firstTimeFlag = false;
    }
  }

  anchorColorChange() {
    let item1 = document.getElementById('AboutUsingLink')?.getElementsByTagName("a") as HTMLCollectionOf<HTMLElement>;
    
    let item2 = document.getElementById('CopyrightLink')?.getElementsByTagName("a") as HTMLCollectionOf<HTMLElement>;
    
    let item3 = document.getElementById('DownloadLink')?.getElementsByTagName("a") as HTMLCollectionOf<HTMLElement>;
    

    if (item1 != undefined) {
      for (let i = 0; i < item1.length; i++) {
        let element = item1[i];
        element.style.color = "#005CBF";
      }
    }
    if (item2 != undefined) {
      for (let j = 0; j < item2.length; j++) {
        let element = item2[j];
        element.style.color = "#005CBF";
      }
    }
    if (item3 != undefined) {
      for (let k = 0; k < item3.length; k++) {
        let element = item3[k];
        element.style.color = "#005CBF";
      }
    }

  }
  getconceptsstatementslabels() {
    this.graphQlService.getConceptsStatementsLabels().subscribe(data => {
      if (data != "") {
        var labels = data.content.data.labels;
        labels = labels.filter(x => x.key.trim());
        this.cs_header = labels.filter(x => x.key == "cs_header").map(y => y.value);
        this.cs_description = labels.filter(x => x.key == "cs_description").map(y => y.value);
        this.cs_notesAboutUsingHeader = labels.filter(x => x.key == "cs_notesAboutUsingHeader").map(y => y.value);
        this.cs_notesAboutUsingBody = labels.filter(x => x.key == "cs_notesAboutUsingBody").map(y => y.value);
        this.cs_notesAboutUsingLink = labels.filter(x => x.key == "cs_notesAboutUsingLink").map(y => y.value);
        this.cs_copyrightNoticeHeader = labels.filter(x => x.key == "cs_copyrightNoticeHeader").map(y => y.value);
        this.cs_copyrightNoticeBody = labels.filter(x => x.key == "cs_copyrightNoticeBody").map(y => y.value);
        this.cs_copyrightNoticeLink = labels.filter(x => x.key == "cs_copyrightNoticeLink").map(y => y.value);
        this.cs_archiveLibraryDescription = labels.filter(x => x.key == "cs_archiveLibraryDescription").map(y => y.value);
        this.cs_downloadLink = labels.filter(x => x.key == "cs_downloadLink").map(y => y.value);
        this.cs_content = labels.filter(x => x.key == "cs_content").map(y => y.value);
        this.cs_supersededcontent = labels.filter(x => x.key == "cs_supersededcontent").map(y => y.value);
        this.cs_supersededrequestheader = labels.filter(x => x.key == "cs_supersededrequestheader").map(y => y.value);

        let parser = new DOMParser();
        let parsedData = parser.parseFromString(this.cs_content, 'text/html');
        let listItems = parsedData.querySelectorAll('span.para');
        let spanArray = [];
        listItems.forEach(a => {
          let newHtml = this.sanitizer.bypassSecurityTrustHtml(a.outerHTML);
          spanArray.push(newHtml);
        });
        this.cs_content_arr = spanArray;
        spanArray = [];
        let sup_parsedData = parser.parseFromString(this.cs_supersededcontent, 'text/html');
        let supItems = sup_parsedData.querySelectorAll('span.para');

        supItems.forEach(a => {
          let newHtml = this.sanitizer.bypassSecurityTrustHtml(a.outerHTML);
          spanArray.push(newHtml);
        });
        this.cs_superseded_arr = spanArray;

        this.commonDataService.showLoader.next(false);
      }
    }, err => {
      console.log(err);
      this.commonDataService.showLoader.next(false);
    });
  }
  openLinkById(event) {
    event.preventDefault();
    this.openlink.openLinkById(event, true);
  }
  onRightClick(event, data?: any) {
    let id = event.target.getAttribute('id');

    if (id.trim()[0] === '/') {
      event.target.href = event.target.id;
    }
    else {
      event.target.href = this.s3baseurl + "/" + event.target.id;
    }
  }
}
